import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {NotificationManager} from "react-notifications";
import * as RaceActions from "../../../../actions/race";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class RaceDecay extends React.Component {

    static propTypes = {
        race: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            club: props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? props.auth.currentEntity : '',
        };
    }

    componentDidMount() {
        if (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id) this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, this.props.auth.currentEntity));
    }

    fields = [];
    render() {
        const pigeonholes = this.props.racePigeons.has(this.props.race.Nr + '/' + this.state.club) ? this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.sort((s1, s2) => s1.Slagnr < s2.Slagnr ? -1 : (s1.Slagnr > s2.Slagnr ? 1 : 0)).toArray() : [];
        return <div className={"form-page race-member-comp"}>
            <div className="top-panel">
                <div className="top-content">
                    <div className="block-content">
                        <table>
                            <tbody>
                            <tr>
                                <td><label className={this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? 'disabled' : ''} htmlFor="club">Forening</label></td>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.enum} placeholder={'-- Vælg --'} className="field100p" containerClassName="display-inline-block field100p" disabled={this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id}
                                                      name="club" id="club" value={this.state.club} options={
                                                          this.props.admin.clubs.filter(c =>
                                                              (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id && c.Sektionsnr !== '99') ||
                                                              (this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && c.Sektionsnr === this.props.auth.currentEntity) ||
                                                              (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && c.Foreningsnr === this.props.auth.currentEntity)
                                                          ).sort((c1, c2) => c1.Foreningsnr < c2.Foreningsnr ? -1 : (c1.Foreningsnr > c2.Foreningsnr ? 1 : 0)).map(club => (
                                                              {key: club.Foreningsnr, value: club.Foreningsnr + (club.Navn === null ? '' : ' - ' + club.Navn)}
                                                          )).toArray()
                                                      }
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={e => {
                                                          this.setState({
                                                              club: e.target.value,
                                                          });
                                                          this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, e.target.value));
                                                      }}
                                                      ref={instance => { this.fields[0] = instance; }}
                                    />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="bottom-panel">
                <div id="data-table" className="bottom-content">
                    <div className="block-content">
                        <table className="data-table">
                            <thead>
                            <th scope="row"></th>
                            <th>Slagnr.</th>
                            <th>Slagnavn</th>
                            </thead>
                            <tbody>
                                {pigeonholes.map(pigeonhole => <tr key={pigeonhole.Slagnr} onDoubleClick={() => {
                                    if (pigeonhole.Forfald) this.props.dispatch(RaceActions.removeDecays(this.props.race.Uge, this.props.race.Nr, this.state.club, [pigeonhole.Slagnr], () => {
                                        NotificationManager.success("Forfald er fjernet for slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + ".", "Forfald", 4000);
                                    })); else this.props.dispatch(RaceActions.addDecays(this.props.race.Uge, this.props.race.Nr, this.state.club, [pigeonhole.Slagnr], () => {
                                        NotificationManager.success("Forfald er registreret for slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + " .", "Forfald", 4000);
                                    }));
                                }}>
                                    <td><input type="checkbox" checked={pigeonhole.Forfald} onChange={() => {
                                        if (pigeonhole.Forfald) this.props.dispatch(RaceActions.removeDecays(this.props.race.Uge, this.props.race.Nr, this.state.club, [pigeonhole.Slagnr], () => {
                                            NotificationManager.success("Forfald er fjernet for slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + ".", "Forfald", 4000);
                                        })); else this.props.dispatch(RaceActions.addDecays(this.props.race.Uge, this.props.race.Nr, this.state.club, [pigeonhole.Slagnr], () => {
                                            NotificationManager.success("Forfald er registreret for slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? null : ' (' + pigeonhole.Slagnavn + ')') + ".", "Forfald", 4000);
                                        }));
                                    }}/></td>
                                    <td>{pigeonhole.Slagnr}</td>
                                    <td>{pigeonhole.Slagnavn}</td>
                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        clubs: state.admin.clubs,
    },
    racePigeons: state.race.racePigeons,
});

export default connect(mapStateToProps, null, null, {withRef: true})(RaceDecay);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/race/subPages/RaceDecay.js